import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsStakeholdersSlice } from './get';
import { putCoreSonarObjectsStakeholdersSlice } from './put';
import { coreSonarObjectsStakeholdersBulkReducers, coreSonarObjectsStakeholdersBulkWatchers } from './bulk';

export const coreSonarObjectsStakeholdersReducers = combineReducers({
	bulk: coreSonarObjectsStakeholdersBulkReducers,
	get: getCoreSonarObjectsStakeholdersSlice.asyncReducers,
	put: putCoreSonarObjectsStakeholdersSlice.asyncReducers
});

export const coreSonarObjectsStakeholdersWatchers = combineAllWatchers([
	coreSonarObjectsStakeholdersBulkWatchers,
	getCoreSonarObjectsStakeholdersSlice.asyncWatchers,
	putCoreSonarObjectsStakeholdersSlice.asyncWatchers
]);
